import { CheckboxGroup, Loading, TextSpan } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { EventTypeOptionResource } from "../../types/eventType";
import { EventTypeMultiSelectField } from "../../ui/EventTypeMultiSelectField";
import { FilterAccordionBody, FilterAccordionItem, FilterCheckbox } from "./AccordionFilterItemStyles";
import { useEventFilterAccordionItems } from "./EventFilterAccordionItemsProvider";

interface Props {
	name: string;
}

export const AccordionItemEventType: FC<Props> = ({ name }) => {
	const { t } = useTranslation();
	const [{ value }, , { setValue }] = useField<EventTypeOptionResource[]>(name);
	const { eventTypes, eventTypesIsLoading, renderEventTypesAsCheckboxes } = useEventFilterAccordionItems();

	if (!eventTypes || !eventTypes.length) {
		return null;
	}

	const renderBody = () => {
		if (eventTypesIsLoading) return <Loading />;
		if (renderEventTypesAsCheckboxes) {
			return (
				<CheckboxGroup name={name}>
					{eventTypes.map((eventType) => (
						<FilterCheckbox
							key={`${eventType.id}`}
							name={`eventType-${eventType.id}`}
							value={value.some((v) => v.id === eventType.id)}
							label={eventType.name}
							onChange={(e) =>
								setValue(e.target.value ? [...value, eventType] : value.filter((v) => v.id !== eventType.id))
							}
						/>
					))}
				</CheckboxGroup>
			);
		}
		return <EventTypeMultiSelectField name={name} label="" />;
	};

	return (
		<FilterAccordionItem
			title={t("Event type")}
			initialOpen={true}
			actions={<TextSpan $size="small">{t("IN_RELATION")}</TextSpan>}
			body={<FilterAccordionBody>{renderBody()}</FilterAccordionBody>}
		/>
	);
};
